import { render, staticRenderFns } from "./unboundModel.vue?vue&type=template&id=1bf69fa9&scoped=true&"
import script from "./unboundModel.vue?vue&type=script&lang=js&"
export * from "./unboundModel.vue?vue&type=script&lang=js&"
import style0 from "./unboundModel.vue?vue&type=style&index=0&id=1bf69fa9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf69fa9",
  null
  
)

export default component.exports